import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatToolbarModule } from "@angular/material/toolbar";
import { NgxsModule } from "@ngxs/store";
import { BottomNavCopyrightModule } from "@vp/shared/bottom-nav/ui/bottom-nav-copyright";
import { FlexModule } from "@vp/shared/directives/flex";
import { NgxPermissionsModule } from "ngx-permissions";
import { BottomNavShellComponent } from "./bottom-nav-shell.component";
@NgModule({
  imports: [
    CommonModule,
    BottomNavCopyrightModule,
    NgxsModule,
    FlexModule,
    MatMenuModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    NgxPermissionsModule.forChild()
  ],
  declarations: [BottomNavShellComponent],
  exports: [BottomNavShellComponent]
})
export class BottomNavShellModule {}
